module.exports = __webpack_public_path__ + "img/ncbc-logo.c4e10372.jpg";